import { set } from 'vue'

export default {
  purgeNotifications (state) {
    state.subjects = []
    state.boards = {}
    state.activeSubjectIdx = 0
    state.activeGroupKey = undefined
    state.openCtas = 0
    state.openReadMes = 0
  },

  setLoading (state, value) {
    state.loading = value
  },
  setOpenReadMes (state, openReadMes) {
    state.openReadMes = openReadMes
  },
  setOpenCtas (state, openCtas) {
    state.openCtas = openCtas
  },
  setPage (state, page) {
    state.page = page
  },
  setTotal (state, total) {
    state.total = total
  },

  pushNotification (state, notification) {
    const messageId = notification?.message?.messageId
    const message = notification.message
    const groupKey = message.groupKey
    let known = false

    // create and update boards
    if (groupKey in state.boards) {
      // message group already exists on board

      const foundIdx = state.boards[groupKey].findIndex(messageOnBoard => messageOnBoard?.messageId === messageId)
      if (foundIdx === -1) {
        // if message not on board yet, create new array of message and dividers and ensure right ordering or messages
        const messages = state.boards[groupKey].slice().filter(message => message.messageId)
        messages.push(message)
        messages.sort(sortByMessageId)
        state.boards[groupKey] = messages
      } else {
        known = true
      }
    } else {
      // if message group is not on board yet, add [header, message]
      set(state.boards, groupKey, [
        message
      ])
    }

    if (known) {
      // console.log('message is known', message)
      return
    }

    // create and update subjects
    const foundIdx = state.subjects.findIndex(subjectMessage => subjectMessage.groupKey === groupKey)
    const messages = state.subjects.slice()
    if (foundIdx === -1) {
      messages.push(message)
    } else {
      const found = state.subjects[foundIdx]
      if (messageId > found.messageId) {
        messages[foundIdx] = message
      }
    }
    messages.sort(sortByMessageId).reverse()
    state.subjects = messages

    if (state.activeGroupKey) {
      const foundIdx = state.subjects.findIndex(message => message.groupKey === state.activeGroupKey)
      if (foundIdx !== -1) {
        state.activeSubjectIdx = foundIdx
      }
    }
  },

  setActiveGroupKey (state, groupKey) {
    /*
    key can be
    'cm24' - everything without an auctionId is in this group
    'a-123' - auctionId
     */
    state.activeGroupKey = groupKey
    const foundIdx = state.subjects.findIndex(message => message.groupKey === groupKey)
    if (foundIdx !== -1) {
      state.activeSubjectIdx = foundIdx
    }
  },

  markAsReadByGroupKey (state, groupKey) {
    const found = state.subjects.find(message => message.groupKey === groupKey)
    if (found) {
      const count = state.boards[groupKey].filter(message => message.messageId && message.read === false &&
        !['Ihr Bietagent ist jetzt aktiv!',
          'Ihr Gebot ist eingegangen',
          'Uw bod is ontvangen'
        ].includes(message.subject)
      ).length
      if (state.openReadMes > count) {
        state.openReadMes -= count
      }

      for (const message of state.boards[groupKey]) {
        if (message.messageId) {
          message.read = true
        }
      }
    }
  }

}

function sortByMessageId (a, b) {
  if (a.messageId < b.messageId) {
    return -1
  }
  return a.messageId > b.messageId ? 1 : 0
}
